import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
// import faker from 'faker';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const StackedChart = (props) => {

    const options = {
        plugins: {
            legend: null
        },
        responsive: true,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    const data = {
        labels: props.labels,
        datasets: [
            {
                label: 'Engaging',
                data: props.engagingValues,
                backgroundColor: 'rgba(0,150,255,255)',
            },
            {
                label: 'Boring',
                data: props.boringValues,
                backgroundColor: '#ffac33',
            },

        ],
    };

    return <Bar options={options} data={data} />;

}


export default StackedChart;

// export function App() {
//     return <Bar options={options} data={data} />;
// }
